document.documentElement.classList.remove('no-js');

const qsa = (s, root=document) => [...root.querySelectorAll(s)];
const body = document.body;

function setOpen(el, open){ if(!el) return; el.classList.toggle('is-open', open); el.setAttribute('aria-hidden', open ? 'false' : 'true'); body.classList.toggle('no-scroll', open); }

const menu = document.querySelector('[data-mobile-menu]');
document.querySelector('[data-menu-toggle]')?.addEventListener('click',()=>setOpen(menu,true));
document.querySelector('[data-menu-close]')?.addEventListener('click',()=>setOpen(menu,false));

const origin = document.querySelector('[data-origin-overlay]');
qsa('[data-origin-open]').forEach(btn=>btn.addEventListener('click',()=>{ setOpen(origin,true); menu?.classList.remove('is-open'); }));
document.querySelector('[data-origin-close]')?.addEventListener('click',()=>setOpen(origin,false));
origin?.addEventListener('click',e=>{ if(e.target===origin) setOpen(origin,false); });

const pass = document.querySelector('[data-password-panel]');
document.querySelector('[data-password-open]')?.addEventListener('click',()=>setOpen(pass,true));
document.querySelector('[data-password-close]')?.addEventListener('click',()=>setOpen(pass,false));

addEventListener('keydown', e=>{ if(e.key==='Escape'){ setOpen(origin,false); setOpen(pass,false); setOpen(menu,false); } });

const io = new IntersectionObserver(entries=>entries.forEach(entry=>{ if(entry.isIntersecting){ entry.target.classList.add('in-view'); io.unobserve(entry.target); } }),{threshold:.12});
qsa('.reveal').forEach(el=>io.observe(el));

const header = document.querySelector('[data-header]');
addEventListener('scroll',()=>{
  if(!header) return;
  header.classList.toggle('is-scrolled', scrollY>24);
},{passive:true});


// V6: light behaves like light across fabric, not a cursor gimmick.
qsa('[data-hero-light]').forEach(surface=>{
  const light=surface.querySelector('[data-hero-light-layer]');
  if(!light || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  surface.addEventListener('pointermove',e=>{
    const r=surface.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
    light.style.transform=`translate3d(${x*38}px,${y*24}px,0)`;
  },{passive:true});
  surface.addEventListener('pointerleave',()=>light.style.transform='translate3d(0,0,0)');
});


// V7 — shopping stays inside the PARELISED environment.
const drawer=document.querySelector('[data-cart-drawer]');
const drawerBackdrop=document.querySelector('[data-cart-backdrop]');
const drawerBody=document.querySelector('[data-cart-drawer-body]');
function money(cents){return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100)}
function openDrawer(){drawer?.classList.add('is-open');drawer?.setAttribute('aria-hidden','false');drawerBackdrop?.classList.add('is-open');body.classList.add('no-scroll')}
function closeDrawer(){drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');drawerBackdrop?.classList.remove('is-open');body.classList.remove('no-scroll')}
document.querySelector('[data-cart-close]')?.addEventListener('click',closeDrawer);
drawerBackdrop?.addEventListener('click',closeDrawer);

async function refreshCartDrawer(){
  if(!drawerBody)return;
  const cart=await fetch('/cart.js').then(r=>r.json());
  qsa('[data-cart-count]').forEach(x=>x.textContent=`(${cart.item_count})`);
  if(!cart.items.length){
    drawerBody.innerHTML='<div class="cart-drawer-empty"><p>Nothing selected.</p><a class="button-light" href="/collections/all">VIEW 001 </a></div>';return;
  }
  drawerBody.innerHTML=cart.items.map(item=>`<div class="drawer-item">
    ${item.image?`<img src="${item.image}" alt="">`:'<div></div>'}
    <div class="drawer-item-copy"><a href="${item.url}">${item.product_title}</a><small>${item.variant_title||''}</small><small>QTY / ${item.quantity}</small></div>
    <div class="drawer-item-price">${money(item.final_line_price)}</div>
  </div>`).join('')+`<div class="drawer-summary"><div class="drawer-summary-row"><span>SUBTOTAL</span><strong>${money(cart.total_price)}</strong></div><a class="add-button drawer-checkout" href="/checkout">CHECKOUT <span></span></a></div>`;
}
qsa('[data-product-form]').forEach(form=>form.addEventListener('submit',async e=>{
  e.preventDefault();
  const btn=form.querySelector('[data-add-to-cart]'), old=btn?.innerHTML;
  if(btn){btn.disabled=true;btn.textContent='ADDING…'}
  try{
    const fd=new FormData(form);
    await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
    await refreshCartDrawer();openDrawer();
  }catch(err){form.submit();return}
  finally{if(btn){btn.disabled=false;btn.innerHTML=old}}
}));


async function refreshVisibleCartCount(){
  try{
    const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
    qsa('[data-cart-count]').forEach(x=>x.textContent=`(${cart.item_count})`);
  }catch(e){}
}
refreshVisibleCartCount();


function syncGlobalCartVisibility(){
  const cart=document.querySelector('.global-cart-link');
  const pass=document.querySelector('[data-password-panel]');
  if(!cart || !pass) return;
  const open=pass.classList.contains('is-open');
  cart.style.opacity=open?'0':'';
  cart.style.visibility=open?'hidden':'';
  cart.style.pointerEvents=open?'none':'';
}
document.querySelector('[data-password-open]')?.addEventListener('click',()=>setTimeout(syncGlobalCartVisibility,0));
document.querySelector('[data-password-close]')?.addEventListener('click',()=>setTimeout(syncGlobalCartVisibility,0));
